// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__1iQPO","body":"style_body__3By1d"};